import { render, staticRenderFns } from "./ReportItemDetail.vue?vue&type=template&id=71651314&scoped=true&"
import script from "./ReportItemDetail.vue?vue&type=script&lang=js&"
export * from "./ReportItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReportItemDetail.vue?vue&type=style&index=0&id=71651314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71651314",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71651314')) {
      api.createRecord('71651314', component.options)
    } else {
      api.reload('71651314', component.options)
    }
    module.hot.accept("./ReportItemDetail.vue?vue&type=template&id=71651314&scoped=true&", function () {
      api.rerender('71651314', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Analysis/components/ReportItemDetail.vue"
export default component.exports